import baseDefaults from '../pqjmdlht5a-1/config.js';

export default {
  ...baseDefaults,
  includes: ['pqjmdlht5a-1'],
};
